// src/components/Charts/BarChart.jsx
import {
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const BarChart = ({ data, xKey, barKeys, colors = ['#3498db', '#2ecc71', '#e74c3c'], height = 400 }) => {
  if (!data || data.length === 0) {
    return <div className="chart-empty">No data available</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <ReBarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} />
        <YAxis />
        <Tooltip />
        <Legend />
        {barKeys.map((key, idx) => (
          <Bar key={key} dataKey={key} fill={colors[idx % colors.length]} />
        ))}
      </ReBarChart>
    </ResponsiveContainer>
  );
};

export default BarChart;